module.exports = __webpack_public_path__ + "static/media/car.11faa06f.svg";